// error statuses returned from the backend
export const INTEGRITY_ERROR = 409;
export const VALIDATION_ERROR = 422;
// options for the model portfolio radio buttons
export const REBALANCE_FREQUENCY_DAILY = 'daily';
export const REBALANCE_FREQUENCY_MONTHLY = 'monthly';
export const REBALANCE_FREQUENCY_QUARTERLY = 'quarterly';
export const REBALANCE_FREQUENCY_ANNUALLY = 'annually';
export const REBALANCE_FREQUENCY_NEVER = 'never';
export const REBALANCE_FREQUENCY_OPTIONS = {
    list: [
        { label: 'Daily', value: REBALANCE_FREQUENCY_DAILY },
        { label: 'Monthly', value: REBALANCE_FREQUENCY_MONTHLY },
        { label: 'Quarterly', value: REBALANCE_FREQUENCY_QUARTERLY },
        { label: 'Annually', value: REBALANCE_FREQUENCY_ANNUALLY },
        { label: 'Never', value: REBALANCE_FREQUENCY_NEVER },
    ],
};
export const TAX_STATUS_QUALIFIED = 'qualified';
export const TAX_STATUS_NON_QUALIFIED = 'non_qualified';
export const TAX_STATUS_DROPDOWN_OPTIONS = {
    list: [
        { label: 'Qualified', value: TAX_STATUS_QUALIFIED },
        { label: 'Non Qualified', value: TAX_STATUS_NON_QUALIFIED },
    ],
};
// Management fees constants
export const MANAGEMENT_FEE_MIN_VALUE = 0.01;
export const MANAGEMENT_FEE_MAX_VALUE = 10;
export const MANAGEMENT_FEE_MONTHLY = 'monthly';
export const MANAGEMENT_FEE_QUARTERLY = 'quarterly';
export const MANAGEMENT_FEE_ANNUALLY = 'annually';
export const MANAGEMENT_FEE_NEVER = null;
export const MANAGEMENT_FEE_OPTIONS = {
    list: [
        { label: 'Monthly', value: MANAGEMENT_FEE_MONTHLY },
        { label: 'Quarterly', value: MANAGEMENT_FEE_QUARTERLY },
        { label: 'Annually', value: MANAGEMENT_FEE_ANNUALLY },
        { label: 'Never', value: MANAGEMENT_FEE_NEVER },
    ],
};
export const START_OF_SERIES_OLDEST = 'oldest';
export const START_OF_SERIES_NEWEST = 'newest';
export const START_OF_SERIES_CUSTOM = 'custom';
export const START_OF_SERIES_OPTIONS = {
    list: [
        { label: 'Earliest', value: START_OF_SERIES_OLDEST },
        { label: 'Custom Date', value: START_OF_SERIES_CUSTOM },
        { label: 'First Common', value: START_OF_SERIES_NEWEST },
    ],
};
export const ADVISORY = 'advisory';
export const BROKERAGE = 'brokerage';
export const SERVICE_TYPE_OPTIONS = {
    list: [
        { label: 'Advisory', value: ADVISORY },
        { label: 'Brokerage', value: BROKERAGE },
    ],
};
export const LEVEL_CUSTOM = 'custom';
export const LEVEL_AUTOCALC = 'auto';
export const CUSTOM_DEFAULT_LEVEL = 10000;
export const AS_OF_LATEST_REBALANCE = 'latest_rebalance';
export const AS_OF_LAST_CLOSE = 'prior_close';
export const AS_OF_INITIAL = 'initial_start';
export const AS_OF_CUSTOM = 'custom_date';
export const AS_OF_OPTIONS = {
    list: [
        { label: 'Latest Rebalance', value: AS_OF_LATEST_REBALANCE },
        { label: 'Last Close', value: AS_OF_LAST_CLOSE },
        { label: 'Initial', value: AS_OF_INITIAL },
        { label: 'Custom', value: AS_OF_CUSTOM },
    ],
};
export const MAX_NAME_LENGTH = 200;
export const MAX_NUM_ITEMS = 505;
export const MAX_HOLDING_PERIODS = 5000;
export const MAX_ITEM_WEIGHT_PRECISION = 4;
export const TOO_MANY_DECIMAL_REGEX = /^0*[0-9]*\.[0-9]{5,}$/;
export const VALID_WEIGHTING_REGEX = /^0*[0-9]*(\.[0-9]{0,4})?$/;
export const VALID_CUSTOM_LEVEL_REGEX = /^0*[0-9]*(\.[0-9]{0,6})?$/;
// format of the empty item
export const EMPTY_MODEL_PORTFOLIO_ITEM = {
    name: '',
    security_id: '',
    display_security_id: '',
    target_weighting: 0,
    current_weighting: 0,
    dollars_weighting: 0,
    shares_weighting: 0,
    weighting: 0,
    weight_text: '',
    exposure_proxy_security_id: '',
    exposure_proxy_display_security_id: '',
    exposure_proxy_name: '',
    avg_cost_basis: null,
};
export const CASH_SECURITY_ID = '$:CASH';
export const CASH_SECURITY_NAME = 'Cash';
export const DEFAULT_CASH_ITEM = {
    name: CASH_SECURITY_NAME,
    target_weighting: 0,
    current_weighting: 0,
    dollars_weighting: 0,
    shares_weighting: 0,
    weighting: 0,
    weight_text: '',
    display_security_id: CASH_SECURITY_ID,
    security_id: CASH_SECURITY_ID,
    avg_cost_basis: null,
};
export const EMPTY_VALID_ITEM_ARRAY = [true, true, true];
export const EMPTY_ITEM_ARRAY = [EMPTY_MODEL_PORTFOLIO_ITEM, EMPTY_MODEL_PORTFOLIO_ITEM, DEFAULT_CASH_ITEM];
export const MODEL_PORTFOLIO_DEFAULT_INITIAL_LEVEL = 10000;
export const MODEL_PORTFOLIO_LEVEL_MIN = 1;
export const MODEL_PORTFOLIO_LEVEL_MAX = 1000000000;
export const ERROR_CYCLE_DETECTED = 'cycle_detected';
export const ERROR_DEPENDENTS_NOT_AVAILABLE = 'dependents_not_available';
export const ERROR_DESCRIPTION_INVALID_TAGS = 'invalid_description_tags';
export const ERROR_ITEMS_WITHOUT_EARLIEST_PERFORMANCE_DATE = 'items_without_earliest_performance_date';
export const ERROR_ITEMS_WITHOUT_LATEST_PERFORMANCE_DATE = 'items_without_latest_performance_date';
export const ERROR_ITEMS_WITH_INVALID_EARLIEST_LATEST_PERFORMANCE_DATE = 'items_with_invalid_earliest_latest_performance_date';
export const ERROR_MISSING_DATA_AS_OF_DATE = 'missing_data_as_of_date';
export const ERROR_MISSING_DATA_AS_OF_DATE_CLIENT_PORTFOLIO = 'missing_data_as_of_date_client_portfolio';
export const ERROR_CUSTOM_LEVEL_TOO_LOW = 'custom_level_too_low';
export const ERROR_CUSTOM_LEVEL_TOO_HIGH = 'custom_level_too_high';
export const ERROR_ZERO_TARGET_WEIGHT = 'items_with_zero_target_weight';
export const ERROR_CANNOT_VIEW_HOLDING = 'cannot_view_holding';
export const ERROR_CANNOT_VIEW_BENCHMARK = 'cannot_view_benchmark';
export const ERROR_INVALID_HOLDING_FOR_HOUSEHOLD = 'invalid_holding_for_household_portfolio';
export const ERROR_CANNOT_HAVE_ALL_ZERO_WEIGHTINGS = 'cannot_have_all_zero_weightings';
export const ERROR_ITEMS_WITH_LATE_EARLIEST_PERFORMANCE_DATE = 'items_with_late_earliest_performance_date';
export const ERROR_ITEMS_WITH_EARLY_LATEST_PERFORMANCE_DATE = 'items_with_early_latest_performance_date';
export const ERROR_CONVERTING_DRAFT = 'invalid_child_draft';
export const ERROR_LEVEL_AS_OF_DATE_EARLIER_THAN_OLDEST_START_DATE = 'level_as_of_date_earlier_than_oldest_security_for_series_start_oldest';
export const ERROR_LEVEL_AS_OF_DATE_EARLIER_THAN_NEWEST_START_DATE = 'level_as_of_date_earlier_than_newest_security_for_series_start_newest';
export const ERROR_LEVEL_AS_OF_DATE_EARLIER_THAN_CUSTOM_START_DATE = 'level_as_of_date_earlier_than_series_start_custom_date';
export const NO_MANAGEMENT_FEE_WARNING = 'Gross performance is prohibited and any PDF report created with this model portfolio may be in ' +
    'violation of the SEC marketing rule. Enter an annualized fee and frequency to be compliant';
export const RECALCULATION_WARNING = 'The changes you made to the model portfolio will require it to be recalculated. ' +
    'You will not be able to access this model portfolio while it is calculating. ' +
    'Do you want to proceed with saving your changes?';
export const ERROR_MESSAGE_DICT = {
    benchmark_has_no_total_return_level: 'The benchmark index you have selected does not have a total ' +
        'return level associated with it. The portfolio reports for this model portfolio will ' +
        'not contain benchmark return information unless you choose a different benchmark.',
    benchmark_shared_with_different_group: 'This model portfolio or one of its components is shared with a ' +
        'different group. Please choose a different benchmark.',
    benchmark_is_legacy: 'The benchmark is not included in your subscription. Please update it.',
    cannot_edit_during_calcs: 'Please try again later when the calculation has finished running.',
    cannot_exceed_max_items: `A model portfolio cannot contain more than ${MAX_NUM_ITEMS} items.`,
    cannot_exceed_max_items_dynamic: `A dynamic model portfolio cannot contain more than ${MAX_NUM_ITEMS} non-zero
    target weighted items per holding period.`,
    cannot_have_all_zero_weightings: 'The following securities have a 0% target weighting for all holding periods: ',
    cannot_use_comparable_benchmark: 'A model portfolio cannot use a comparable security as its own benchmark.',
    cannot_view_benchmark: 'You do not have access to the selected benchmark.',
    cannot_view_holding: 'You do not have access to the selected model portfolio.',
    cycle_detected: 'The following Model Portfolios cannot be used since they create a circular reference back to ' +
        'the current Model Portfolio being edited: ',
    custom_level_too_low: 'Chosen custom level is below the allowed limit.',
    custom_level_too_high: 'Chosen custom level is above the allowed limit.',
    data_not_available: 'We are only able to use target weights because one or more securities does not have up to ' +
        'date performance data. Please select target weights or edit your holdings.',
    dates_must_be_in_order: 'The holding period dates must be in chronological order.',
    default_error: 'Something went wrong when trying to save the model portfolio. Please try again.',
    dependents_not_available: 'The following Model Portfolios cannot be used since they are currently not Available: ',
    descendant_shared_with_different_group: 'This model portfolio or one of its components is shared with a ' +
        'different group. Please choose a different security.',
    custom_security_shared_with_different_group: 'This custom security is shared with a different group. Please choose a different security.',
    duplicate_name: 'A model portfolio with this name exists already. Please change the name of the model portfolio.',
    dynamic_mp_cant_have_blended_benchmark: 'A dynamic model portfolio needs to have a Index benchmark',
    dynamic_mp_cant_have_sleeve: 'A dynamic model portfolio cannot have another model portfolio as its holding',
    empty_name: 'Please enter a name for the model portfolio.',
    fixed_model_portfolio_only: 'This feature is only for Fixed Model Portfolios',
    holding_later_than_proxy_end: 'The items earliest performance date must come before the proxys latest performance' +
        ' date to ensure there is no gap in portfolio levels.',
    holding_older_than_proxy: 'The items earliest performance date must come after the proxys earliest performance date.',
    holding_period_weights_and_dates_variation: 'The number of weightings per item need to be the same as the total number of holding period dates.',
    invalid_benchmark: 'Please select a valid benchmark index.',
    invalid_dollars_weighting: 'All items in the portfolio need to have positive dollar values.',
    invalid_imported_holdings: 'Some of the imported symbols do not match YCharts securities. Please name a proxy security.',
    invalid_holding_for_household_portfolio: 'Household portfolios can only contain model portfolios and client portfolios as holdings.\n' +
        'The following items are invalid: ',
    invalid_extracted_holdings: 'Some of the symbols extracted from the file do not match YCharts securities. Please correct the symbols or choose a proxy security.',
    imported_short_holdings: 'Some of the imported assets appear to be short positions. ' +
        'Please choose a proxy security and adjust the weights.',
    invalid_custom_level: `Custom level must be a number between ${MODEL_PORTFOLIO_LEVEL_MIN}
    and ${MODEL_PORTFOLIO_LEVEL_MAX}.`,
    invalid_custom_dates: `Level as of date must be after the start of series date.`,
    invalid_description_tags: 'The description has some format options not allowed.',
    invalid_item_target_weighting: 'Item weight must be between 0% and 100% (Not including 0%).',
    invalid_negative_item_weighting_percentage: 'Item weight must be greater than 0%.',
    invalid_negative_item_weighting_shares: 'Number of shares must be greater than 0.',
    invalid_negative_item_weighting_dollars: 'Dollar amount must be greater than 0.',
    invalid_item_target_weighting_dynamic: 'Item weight must be from 0% to 100% (Including 0%).',
    // If the application is used properly, this should never happen.
    invalid_management_fee: `Management fee must be a number between ${MANAGEMENT_FEE_MIN_VALUE}%
    and ${MANAGEMENT_FEE_MAX_VALUE}%.`,
    // This should not happen either.
    invalid_management_fee_frequency: 'Please select a valid management fee frequency.',
    invalid_rebalance_frequency: 'The rebalance frequency most be monthly or quarterly.',
    invalid_start_of_series: 'The start of series history must be oldest security or newest security.',
    invalid_target_weightings: 'Weight must add up to 100%.',
    invalid_custom_resulting_allocations: 'Resulting allocations must add up to 100%',
    invalid_custom_start_of_series: 'Please enter a value for start of series.',
    invalid_weight_type: 'The weight type entered is invalid. Please set weight type to one of the following: ' +
        'Current, Dollars, Shares, Target.',
    invalid_portfolio_label: 'The Label entered is invalid. Please set portfolio label to one of the following: ' +
        'Model Portfolio, Blended Benchmark, Client Portfolio.',
    items_with_late_earliest_performance_date: 'The following securities are missing data for the dates currently selected: ',
    items_with_early_latest_performance_date: 'The following securities are missing data for the dates currently selected: ',
    items_with_invalid_earliest_latest_performance_date: 'The portfolio cannot be calculated because the following securities ' +
        'do not have data going back to the start date of the portfolio: ',
    items_without_earliest_performance_date: 'The following securities seem to be missing data: ',
    items_without_latest_performance_date: 'The following securities seem to be missing data: ',
    level_as_of_date_earlier_than_newest_security_for_series_start_newest: 'As of date cannot be earlier than the newest security\'s earliest performance date when using the "First Common" start of series.',
    owner_no_access: 'The following securities cannot be used since the owner does not have access to them: ',
    management_fee_frequency_missing: 'Please select a valid management fee frequency.',
    service_type_missing: 'Please select a valid service type.',
    management_fee_missing: `Enter fee between ${MANAGEMENT_FEE_MIN_VALUE}% and ${MANAGEMENT_FEE_MAX_VALUE}%.`,
    mismatched_shared_item: 'The following securities cannot be used since they are shared with a different group: ',
    missing_security: 'Please select a security.',
    missing_data_as_of_date: 'We are unable to use any data input option outside of "target weight" because one or more securities' +
        ' do not have performance data on the "as of" date selected. Please select an "as of" option that does' +
        ' have data for all of the portfolio holdings entered, or use the "target weight" data input method.',
    missing_data_as_of_date_client_portfolio: 'We are unable to save the portfolio because one or more securities do not have performance data on the' +
        '"as of" date selected. Please select an "as of" option that does have data for all of the portfolio ' +
        'holdings entered.',
    not_a_number: 'Please input a number for the weight.',
    security_no_longer_exists: 'The security you selected no longer exists in our database. Please select a different security.',
    reached_max_holding_periods: `A dynamic model portfolio cannot contain more than ${MAX_HOLDING_PERIODS} max holding periods.`,
    security_not_found: 'We are unable to use current weights because one or more securities cannot be found in our ' +
        'database. Please select target weights or edit your holdings.',
    self_referencing_benchmark: 'A model portfolio cannot use itself as its own benchmark.',
    series_start_earliest_with_autocalc_initial: 'The autocalc option will only work for a date where all portfolio holdings have data.' +
        ' Please select a different as of date to use the autocalc option.',
    some_items_are_legacy: 'Some holdings or proxies are not included in your subscription. Please update them.',
    too_many_decimals: `${MAX_ITEM_WEIGHT_PRECISION} decimal places maximum.`,
    no_items_added: 'Please add items before updating.',
    items_with_zero_target_weight: 'Using the calculation to create the model portfolio, the following securities ' +
        'have a weight that is too small for the portfolio to be calculated:',
    invalid_avg_cost_basis: 'Avg. Cost Basis per Share should be a number greater than 0.01',
    invalid_child_draft: 'We are unable to create a portfolio from draft portfolio: ',
    missing_avg_cost_basis: 'Some items are missing the value for avg. cost basis per share.',
};
export const DMP_SAVE_TOOLTIP_TEXT_DICT = {
    emptyName: '<div class="multi-line-tooltip">Add portfolio name<br>in order to save</div>',
    invalidBenchmark: '<div class="multi-line-tooltip">Select a valid benchmark<br>in order to save</div>',
    isInvalidManagementFee: '<div class="multi-line-tooltip">Enter a valid management fee<br>in order to save</div>',
    isInvalidCustomLevel: '<div class="multi-line-tooltip">Enter a valid custom level<br>in order to save</div>',
    invalidItems: '<div class="multi-line-tooltip">Upload valid items <br>in order to save</div>',
};
export const FIXED_SAVE_TOOLTIP_TEXT_DICT = {
    isEditingItems: '<div class="multi-line-tooltip">Update portfolio items<br>in order to save</div>',
    isEmptyName: '<div class="multi-line-tooltip">Add portfolio name<br>in order to save</div>',
    isInvalidBenchmark: '<div class="multi-line-tooltip">Select a valid benchmark<br>in order to save</div>',
    isInvalidManagementFee: '<div class="multi-line-tooltip">Enter a valid management fee<br>in order to save</div>',
    isInvalidCustomLevel: '<div class="multi-line-tooltip">Enter a valid custom level<br>in order to save</div>',
    isInvalidAutocalc: '<div class="multi-line-tooltip">Enter a valid as of date in order to save</div>',
    isInvalidCustomDates: '<div class="multi-line-tooltip">Select a valid start of series and level as of date<br>in order to save</div>',
};
export const DATA_INPUT_TARGET_WEIGHT = 'Target';
export const DATA_INPUT_CURRENT_WEIGHT = 'Current';
export const DATA_INPUT_SHARES = 'Shares';
export const DATA_INPUT_DOLLARS = 'Dollars';
export const DATA_INPUT_TARGET_WEIGHT_LABEL = 'Target Weight';
export const DATA_INPUT_CURRENT_WEIGHT_LABEL = 'Current Weight';
export const DATA_INPUT_SHARES_LABEL = 'Shares';
export const DATA_INPUT_DOLLARS_LABEL = 'Dollars';
export const DATA_INPUT_DROPDOWN_OPTIONS = {
    list: [
        { label: DATA_INPUT_TARGET_WEIGHT_LABEL, value: DATA_INPUT_TARGET_WEIGHT },
        { label: DATA_INPUT_CURRENT_WEIGHT_LABEL, value: DATA_INPUT_CURRENT_WEIGHT },
        { label: DATA_INPUT_SHARES_LABEL, value: DATA_INPUT_SHARES },
        { label: DATA_INPUT_DOLLARS_LABEL, value: DATA_INPUT_DOLLARS },
    ],
};
export const CLIENT_PORTFOLIO_DATA_INPUT_DROPDOWN_OPTIONS = {
    list: [
        { label: DATA_INPUT_CURRENT_WEIGHT_LABEL, value: DATA_INPUT_CURRENT_WEIGHT },
        { label: DATA_INPUT_SHARES_LABEL, value: DATA_INPUT_SHARES },
        { label: DATA_INPUT_DOLLARS_LABEL, value: DATA_INPUT_DOLLARS },
    ],
};
export const HOUSEHOLD_PORTFOLIO_DATA_INPUT_DROPDOWN_OPTIONS = {
    list: [{ label: DATA_INPUT_DOLLARS_LABEL, value: DATA_INPUT_DOLLARS }],
};
export const BENCHMARK_PORTFOLIO_DATA_INPUT_DROPDOWN_OPTIONS = {
    list: [
        { label: DATA_INPUT_TARGET_WEIGHT_LABEL, value: DATA_INPUT_TARGET_WEIGHT },
        { label: DATA_INPUT_CURRENT_WEIGHT_LABEL, value: DATA_INPUT_CURRENT_WEIGHT },
    ],
};
export const MODEL_PORTFOLIO_LABEL = 'model_portfolio';
export const BLENDED_BENCHMARK_LABEL = 'blended_benchmark';
export const CLIENT_PORTFOLIO_LABEL = 'client_portfolio';
export const HOUSEHOLD_PORTFOLIO_LABEL = 'household_portfolio';
export const VALID_SERVICE_TYPE_PORTFOLIO_TYPES = [MODEL_PORTFOLIO_LABEL, CLIENT_PORTFOLIO_LABEL];
export const MODEL_PORTFOLIO_DEFAULT_STATE = {
    name: '',
    description: '',
    benchmark_symbol: '^SPXTR',
    historical_performance: null,
    management_fee_frequency: MANAGEMENT_FEE_NEVER,
    custom_level: CUSTOM_DEFAULT_LEVEL,
    label: MODEL_PORTFOLIO_LABEL,
    level_type: LEVEL_CUSTOM,
    level_as_of_type: AS_OF_INITIAL,
    level_as_of_date: null,
    rebalance_frequency: REBALANCE_FREQUENCY_QUARTERLY,
    reinvest_dividends: false,
    show_avg_cost_basis: false,
    show_exposure_proxy: false,
    show_performance_proxy: false,
    start_of_series: START_OF_SERIES_OLDEST,
    series_start_level_date: null,
    management_fee: null,
    service_type: null,
    weight_type: DATA_INPUT_TARGET_WEIGHT,
    tax_status: null,
    imported_holdings_id: null,
    uses_legacy_data: false,
};
export const DYNAMIC_MODEL_PORTFOLIO_DEFAULT_STATE = {
    name: '',
    description: '',
    benchmark_symbol: '^SPXTR', // S&P 500 Total Return
    rebalance_frequency: REBALANCE_FREQUENCY_QUARTERLY,
    start_of_series: 'newest',
    model_portfolio_data_upload_count: 0,
    management_fee_frequency: MANAGEMENT_FEE_NEVER,
    management_fee: null,
    custom_level: MODEL_PORTFOLIO_DEFAULT_INITIAL_LEVEL,
    uses_legacy_data: false,
};
export const MODEL_PORTFOLIO = 'model';
export const BENCHMARK_PORTFOLIO = 'benchmark';
export const CLIENT_PORTFOLIO = 'client';
export const HOUSEHOLD_PORTFOLIO = 'household';
export const FULL_TRANSITION = 'full_transition';
export const TAX_EFFICIENT_TRANSITION = 'tax_efficient';
export const CUSTOM_TRANSITION = 'custom';
export const AGGREGATE_TRANSITION = 'aggregate';
export const DIRECT_HOLDINGS = 'direct_holdings';
export const INVESTED_HOLDINGS = 'invested_holdings';
export const UNDERLYING_HOLDINGS = 'underlying_holdings';
export const HOLDINGS_LAYER_DROPDOWN_CONFIG = {
    list: [
        { value: DIRECT_HOLDINGS, label: 'Holdings' },
        { value: INVESTED_HOLDINGS, label: 'Invested Holdings' },
        { value: UNDERLYING_HOLDINGS, label: 'Underlying Holdings' },
    ],
};
export const SHARES_FORMAT = 'shares';
export const DOLLARS_FORMAT = 'dollars';
export const TRANSITION_GROUP_TYPE_CATEGORY = 'broad_asset_class';
export const TRANSITION_GROUP_TYPE_PORTFOLIO = 'account';
export const TRANSITION_GROUP_TYPE_TAX_STATUS = 'tax_status';
export const TRANSITION_ANALYSIS_VIEW_BY_OPTIONS = {
    list: [
        {
            type: 'option',
            label: 'Category',
            value: TRANSITION_GROUP_TYPE_CATEGORY,
        },
        {
            type: 'option',
            label: 'Portfolio',
            value: TRANSITION_GROUP_TYPE_PORTFOLIO,
        },
        {
            type: 'option',
            label: 'Tax Status',
            value: TRANSITION_GROUP_TYPE_TAX_STATUS,
        },
    ],
};
export const DEFAULT_ADVANCED_PORTFOLIO_OPTIONS = {
    exposureProxy: false,
    historicalPerformance: true,
    showAvgCostBasis: false,
    reinvestDividends: false,
    performanceProxy: true,
};
export const MODEL_PORTFOLIO_ADVANCED_PORTFOLIO_OPTIONS = {
    exposureProxy: true,
    historicalPerformance: true,
    showAvgCostBasis: false,
    reinvestDividends: false,
    performanceProxy: true,
};
export const CLIENT_PORTFOLIO_ADVANCED_PORTFOLIO_OPTIONS = {
    exposureProxy: false,
    historicalPerformance: true,
    showAvgCostBasis: true,
    reinvestDividends: false,
    performanceProxy: true,
};
export const HOUSEHOLD_PORTFOLIO_ADVANCED_PORTFOLIO_OPTIONS = {
    exposureProxy: false,
    historicalPerformance: true,
    showAvgCostBasis: false,
    reinvestDividends: false,
    performanceProxy: false,
};
export const BENCHMARK_ADVANCED_PORTFOLIO_OPTIONS = {
    exposureProxy: true,
    historicalPerformance: true,
    showAvgCostBasis: false,
    reinvestDividends: false,
    performanceProxy: true,
};
export const PORTFOLIO_TYPE_TO_LABEL = {
    model: MODEL_PORTFOLIO_LABEL,
    benchmark: BLENDED_BENCHMARK_LABEL,
    client: CLIENT_PORTFOLIO_LABEL,
    household: HOUSEHOLD_PORTFOLIO_LABEL,
};
export const PORTFOLIO_LABEL_TO_URL_SLUG = {
    model_portfolio: 'model',
    blended_benchmark: 'benchmark',
    client_portfolio: 'client',
    household_portfolio: 'household',
};
export const PORTFOLIO_LABEL_DESCRIPTION = {
    model_portfolio: 'Model Portfolio',
    blended_benchmark: 'Blended Benchmark',
    client_portfolio: 'Client Portfolio',
    household_portfolio: 'Household Portfolio',
    null: '--',
};
